export default __webpack_public_path__ + "static/media/sign-out.d418b406.svg";